import React, { useEffect, useState } from 'react';

import Paper from '@material-ui/core/Paper';
import EventIcon from '@material-ui/icons/Event';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

import PreorderEventAccordion from './PreorderEventAccordion';
import PreorderEventFiltersComponent from './PreorderEventFilters';
import AddPreorderEventModal from './AddPreorderEventModal';

import { RootStore } from "../../../Store";
import { useDispatch, useSelector } from "react-redux";
import { getAllPreorderEvents, refreshPreorderEventsView } from '../../../actions/preorderEventActions/PreorderEventActions';

import { useTranslation } from 'react-i18next';

import useStyles from './PreorderEventListStyles';

const PreorderEventList = () => {
  const classes = useStyles();
  const [t] = useTranslation('global');
  const dispatch = useDispatch();

  const [openAddModal, setOpenAddModal] = useState(false);

  const preorderEventState = useSelector((state: RootStore) => state.preorderEvents);
  const { loading, refresh, preorderEventFilters } = preorderEventState;

  // Load preorder events when component mounts or when refresh is triggered
  useEffect(() => {
    const qParams = {
      page: preorderEventFilters?.page || 0,
      size: preorderEventFilters?.size || 10,
      sort: 'id,desc',
      ...(preorderEventFilters?.name && { name: preorderEventFilters.name }),
      ...(preorderEventFilters?.archived !== undefined && { archived: preorderEventFilters.archived }),
      ...(preorderEventFilters?.releaseDate && { releaseDate: preorderEventFilters.releaseDate }),
      ...(preorderEventFilters?.lastPreorderDate && { lastPreorderDate: preorderEventFilters.lastPreorderDate }),
    };
    
    dispatch(getAllPreorderEvents(qParams));
  }, [dispatch, preorderEventFilters]);

  // Handle refresh trigger
  useEffect(() => {
    if (refresh) {
      const qParams = {
        page: preorderEventFilters?.page || 0,
        size: preorderEventFilters?.size || 10,
        sort: 'id,desc',
        ...(preorderEventFilters?.name && { name: preorderEventFilters.name }),
        ...(preorderEventFilters?.archived !== undefined && { archived: preorderEventFilters.archived }),
        ...(preorderEventFilters?.releaseDate && { releaseDate: preorderEventFilters.releaseDate }),
        ...(preorderEventFilters?.lastPreorderDate && { lastPreorderDate: preorderEventFilters.lastPreorderDate }),
      };
      
      dispatch(getAllPreorderEvents(qParams));
      dispatch(refreshPreorderEventsView(false));
    }
  }, [refresh, dispatch, preorderEventFilters]);

  const handleOpenAddModal = () => {
    setOpenAddModal(true);
  };

  const handleCloseAddModal = () => {
    setOpenAddModal(false);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={3} className={classes.paper}>
        <div className={classes.boxTop}>
          <EventIcon color='primary' fontSize="large"/>
          <Typography variant="h4" color="primary" className={classes.sectionTitle}>
            {t('preorderEvents.preorder-events-list')} {loading === 'GET_PREORDER_EVENTS' && <CircularProgress/>}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            className={classes.addButton}
            startIcon={<AddIcon />}
            onClick={handleOpenAddModal}
          >
            {t('preorderEvents.add-preorder-event')}
          </Button>
        </div>
        
        <PreorderEventFiltersComponent />
        
        <div>
          <PreorderEventAccordion />
        </div>
      </Paper>

      <AddPreorderEventModal 
        open={openAddModal}
        onClose={handleCloseAddModal}
      />
    </div>
  );
};

export default PreorderEventList;